import { firebaseAuth } from "../../firebaseConfig";

/**
 * Resolve the current user's Firebase ID token for REST API calls made outside
 * React context (e.g. model write methods). Mirrors the implicit auth the
 * Firestore SDK used to provide, so call-site signatures stay unchanged.
 *
 * Throws when no user is signed in, matching the previous behaviour where a
 * write would fail without an authenticated session.
 */
export const getApiToken = async (): Promise<string> => {
  const currentUser = firebaseAuth.currentUser;
  if (!currentUser) {
    throw new Error("Not authenticated");
  }
  return currentUser.getIdToken();
};
